import { render, staticRenderFns } from "./NewJourney.vue?vue&type=template&id=2443231f&scoped=true&"
import script from "./NewJourney.vue?vue&type=script&lang=js&"
export * from "./NewJourney.vue?vue&type=script&lang=js&"
import style0 from "./NewJourney.vue?vue&type=style&index=0&id=2443231f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2443231f",
  null
  
)

export default component.exports